import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import WhatIfStepNavigator from 'Views/Page/Content/Modal/Components/WhatIfStepNavigator';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import WizardStepDeleteButton
  from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/Content/WizardStepDeleteButton';
import DocumentUploader
  from 'Views/Page/Content/Templates/WizardTemplates/WizardAttachmentsTemplate/Content/DocumentUploader';
import useMobileLayout from 'Hooks/useMobileLayout';

const styles = (theme) => ({
  root: {},

  container: {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    maxWidth: '400px',
    alignItems: 'center',
    flexDirection: 'column',
    marginBottom: theme.spacing(10),
  },
  containerDesktop: {
    maxWidth: '600px',
  },
  content: {
    width: '100%',
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(4),
  },
  subtitle: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(4),
  },
});

const Layout = ({
  className,
  classes,
}) => {
  const { loadModalCollectionByLink, setModalCollection, refreshModalCollection } = useModalContext();

  const {
    resource,
    onSubmit,
    saving,
  } = useMetaLayoutContext();

  const isMobile = useMobileLayout();

  const previousLink = resource.relationship(fr.relationships.previousLink.name)?.link('related');

  async function handleDelete() {
    if (resource.id() > 0 && resource.meta().action('DELETE')) {
      return resource.delete();
    }
    return null;
  }

  function handleDeleteSuccess(responseCollection) {
    setModalCollection(responseCollection);
  }

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <div className={classNames(classes.container, {
        [classes.containerDesktop]: !isMobile,
      })}
      >
        {resource.attr('title')
          ? <Title className={classes.title} text={resource.attr('title')} test={'wizard-step-title'} /> : null}
        {resource.attr('subtitle')
          ? <Subtitle className={classes.subtitle} text={resource.attr('subtitle')} test={'wizard-step-subtitle'} /> : null}
        <Box className={classes.content}>
          <MetaFormFields
            className={classes.fields}
            resource={resource}
          />
          {resource.meta().action('DELETE') ? <WizardStepDeleteButton
            onDelete={handleDelete}
            onDeleteSuccess={handleDeleteSuccess}
            dialogProps={{
              title: 'Are you sure?',
              message: 'Removing this item will delete all of its information. This cannot be undone.',
              cancelLabel: 'Nevermind',
              confirmLabel: 'Remove',
            }}
          /> : null}
          {resource.attr('attachments') ? <DocumentUploader resource={resource} refreshCollection={refreshModalCollection} onAttachmentCreate={refreshModalCollection} /> : null }
        </Box>
      </div>
      <WhatIfStepNavigator
        isLoading={saving}
        onNext={() => {
          onSubmit();
        }}
        onPrevious={(previousLink) ? () => {
          loadModalCollectionByLink(previousLink.url());
        } : null}
      />
    </Box>
  );
};

Layout.defaultProps = {
  className: '',
};

Layout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
